<template>
  <vs-popup class="sales-quote-email-log-popup"
            id="popup"
            :title='`PRODUCT ORDER CONFIRMATION SENT LOG`'
            :active.sync="open"
            :buttons-hidden="true">
    <vs-table class="my-8" hoverFlat id="quote_item_table" :data="sentLog" stripe>
      <template slot="thead">
        <vs-th>ORDER CODE</vs-th>
        <vs-th>DATE/TIME</vs-th>
        <vs-th>STAFF USER (SENT BY)</vs-th>
        <vs-th>CUSTOMER USER (SENT TO)</vs-th>
        <vs-th>CUSTOMER USER EMAIL</vs-th>
      </template>
      <template slot-scope="{data}">
        <vs-tr :key="indextr"
               v-for="(tr_item, indextr) in data">
          <vs-td :data="data[indextr].number">
            {{data[indextr].order_code}}
          </vs-td>
          <vs-td :data="data[indextr].created_at">
            {{ __dateTimeFormatter(data[indextr].created_at) }}
          </vs-td>
          <vs-td>
            {{ data[indextr].created_by_staff_name }}
          </vs-td>
          <vs-td>
            {{ data[indextr].customer_user_name }}
          </vs-td>
          <vs-td>
            {{ data[indextr].customer_user_email }}
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
  </vs-popup>
</template>

<script>
import {RepositoryFactory} from '@/repository/RepositoryFactory';
const CustomerRepository = RepositoryFactory.get('customer')

export default {
  name: "ProductOrderConfirmationSentLogPopUp",
  data() {
    return {
      orderId:null,
      open: false,
      sentLog: []
    }
  },
  methods:{
    async openPopUp(id){
      this.orderId = id
      await this.fetchConfirmationLog()
      this.open = true
    },
    async fetchConfirmationLog(){
      this.$vs.loading()
      const {data} = await CustomerRepository.getProductOrderConfirmationSentLog(this.orderId)
      this.sentLog = data.data || []
      this.$vs.loading.close()
    }
  }
}
</script>

<style scoped>

.sales-quote-email-log-popup >>> .vs-popup {
  min-width: 50% !important;
}

</style>
